<template>
	<div class="iamge_content">
		<div class="iamge_content_address">
			<div class="image_content_title">联系我们</div>
			<div class="image_content_address_bg">
				<div class="address_grid">
					<div class="signal_address" v-for="(address, index) in addresses" :key="index">
						<div class="signal_address_name">{{ address.name }}</div>
						<div class="signal_address_address">{{ address.address }}</div>
						<div class="signal_address_tel">{{ address.tel }}</div>
					</div>
				</div>
			</div>
		</div>

		<CopyrightBottom></CopyrightBottom>
	</div>
</template>

<script type="text/javascript">
	import Vue from "vue";
    import store from '@/store/index.js';
    
import { ImagePreview } from 'vant'

	export default{
		name:"contactUs",
		data(){
			return{
				companyImg:'',
				addresses:[
					{
						'name':'同和金属材料（上海）有限公司',
						'address':'上海市松江综合保税区茸翔路8号第7-8号厂房',
						'tel':'TEL. 021-57748118    FAX. 021-57748338',
					},
					{
						'name':'同和新材料（上海）有限公司',
						'address':'上海市松江综合保税区茸翔路8号第7-8号厂房',
						'tel':'TEL. 021-57748118    FAX. 021-57748338',
					},
					{
						'name':'同和金属技术(南通)有限公司',
						'address':'江苏省南通市如东经济开发区牡丹江路107号',
						'tel':'TEL. 0513-80159889    FAX. 0513-80157889',
					},
					{
						'name':'同和利精密部品股份有限公司',
						'address':'桃園市楊梅區和平路236巷31弄3號　台湾',
						'tel':'TEL. +886-3-475-8400    FAX.+886-3-475-7270',
					},
					{
						'name':'同和企业管理（上海）有限公司',
						'address':'上海市长宁区金钟路999号D栋903室',
						'tel':'TEL. 021-62752121    FAX. 021-62755252',
					},
					{
						'name':'同和企业管理（上海）有限公司深圳分公司',
						'address':'广东省深圳市南山区蛇口太子路1号新时代广场23层E室',
						'tel':'TEL. 0755-21607358    FAX. 0755-21607359',
					},
					{
						'name':'    DOWAメタルテック株式会社 金属加工事業部',
						'address':'〒430-7727 静岡県浜松市中区板屋町111-2浜松アクトタワー27F',
						'tel':'TEL. 053-453-4221    FAX. 053-453-4225',
					},
					{
						'name':'DOWAメタル株式会社',
						'address':'〒438-0125 静岡県磐田市松之木島767',
						'tel':'TEL.+0081-0539-62-3131    FAX.+0081-0539-62-3996',
					},
					{
						'name':'DOWAメタニクス株式会社',
						'address':'〒438-0025 静岡県磐田市新貝2630',
						'tel':'TEL.+0081-0539-62-3131    FAX.+0081-0539-62-3996',
					},
					{
						'name':'DOWA METALTECH(THAILAND)CO.,LTD',
						'address':'177/1 Moo7,Gateway City Industrial Estate,T.Huasamrong,A.Plaengyao,Chachoengsao 24190 Thailand',
						'tel':'TEL.+0066-38-575-715    FAX.+0066-38-575-684',
					},
					{
						'name':'DOWAホールディングス（株）',
						'address':'〒101-0021 東京都千代田区外神田四丁目14番1号秋葉原UDX 22',
						'tel':'TEL : 03-6847-1106 FAX : 03-6847-1272',
					},
				]
			}
		},

		computed:{
            needBigImages(){
				return store.state.needBigImages;
			},
			allProductDate(){
				return store.state.product_data;
			}
		},

		methods:{
            openBigImg(e){
                console.log(e)
                console.log(e.currentTarget.src)
                store.state.needBigImages = [e.currentTarget.src]
            }
        },
        watch: {
            needBigImages:{
				immediate:true,
				deep:true,
                handler:function(newValue,oldValue){
                    console.log(newValue)
                    // ImagePreview({
                    //     images:["https://resources.xycoder.com/dowa/CompanyIntroduction-3.jpeg"],
                    //     startPosition:0,
                    // })
                }
			},
			allProductDate:{
				immediate:true,
				deep:true,
				handler:function(newValue,oldValue){
					var self = this;
					if (newValue == null || newValue.config == null) {
						 return
					 }
					 console.log(newValue)
					self.companyImg = newValue.config.contact_us_url
				}
			}
        },
	}

</script>

<style type="text/css" scoped>
	.iamge_content {
		width: 100%;
		margin: 0;
		padding: 0;
	}
	.image_content_title {
		text-align: center;
		line-height: 100px;
		height: 90px;
		position: relative;
		color: white;
		padding: 40px 0 0 0;
		font-size: x-large;
	}
	.iamge_content_address {
		background-image: url(https://resources.xycoder.com/dowa/images/address_bg.png);
		background-size: cover;
		background-position: center;
		padding-bottom: 40px;
	}
	.image_content_address_bg {
		background: rgba(255, 255, 255, 0.7);
		margin: 0 40px;
		border-radius: 8px;
		padding: 16px 20px 24px;
		max-width: 100%;
		box-sizing: border-box;
	}
	.address_grid {
		display: grid;
		grid-template-columns: 1fr;
		gap: 16px;
	}
	.signal_address {
		text-align: left;
		padding: 12px 16px;
		background: rgba(255, 255, 255, 0.6);
		border-radius: 6px;
		border: 1px solid rgba(19, 136, 142, 0.15);
		min-width: 0;
	}
	.signal_address_name {
		color: rgb(19, 136, 142);
		font-size: 13px;
		font-weight: 900;
		line-height: 1.4;
		word-break: break-all;
		margin-bottom: 6px;
	}
	.signal_address_address {
		color: rgb(19, 136, 142);
		font-size: 11px;
		line-height: 1.5;
		word-break: break-all;
		margin-bottom: 4px;
	}
	.signal_address_tel {
		color: rgb(19, 136, 142);
		font-size: 10px;
		line-height: 1.4;
		word-break: break-all;
	}

	/* PC 端适配：加宽内容区、多列布局、更大字号 */
	@media (min-width: 768px) {
		.image_content_address_bg {
			margin: 0 auto;
			max-width: 1100px;
			padding: 24px 32px 32px;
		}
		.address_grid {
			grid-template-columns: repeat(2, 1fr);
			gap: 20px;
		}
		.signal_address {
			padding: 20px 24px;
		}
		.signal_address_name {
			font-size: 15px;
			margin-bottom: 8px;
		}
		.signal_address_address {
			font-size: 13px;
			margin-bottom: 6px;
		}
		.signal_address_tel {
			font-size: 12px;
		}
	}
	@media (min-width: 1200px) {
		.address_grid {
			grid-template-columns: repeat(3, 1fr);
			gap: 24px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/ContactUs.vue